import React, { FC } from 'react';
import { Input } from '@goldbely/explore-component-library';
import { useForm } from 'react-hook-form';

import Submit from './atoms/Submit';

import styles from './index.module.sass';

const Form: FC = () => {
  const { register, watch } = useForm();
  const { q }: { q?: string } = watch();

  return (
    <form action="/search" className={styles.container} method="get">
      <Input
        className={styles.input}
        errors={{}}
        id="q"
        name="q"
        placeholder="Search"
        register={register}
        type="text"
      />

      <Submit className={styles.submit} disabled={!q} />
    </form>
  );
};

export default Form;
